import React, { useState } from 'react'



export const Textform = (props) => {
    const [inputText, setText] = useState('');
    var words = inputText.split(" ").length;
    var letters = inputText.length;


    const handleUpClick = () => {
        var mystring = inputText.toUpperCase();
        setText(mystring);
    }

    const handleLoClick = () => {
        var mystring = inputText.toLowerCase();
        setText(mystring);
    }

    const handleClear = () => {
        setText("");
    }

    const handleOnChange = (event) => {
        setText(event.target.value);
    }

    const handleHtml = () => {
        let mystr = inputText.replaceAll("class=","className=");
        mystr = mystr.replaceAll('href="#"','href="/"')
        setText(mystr);
    }
    return (
        <>
            <div>
                <div className="mb-3">
                    <label htmlFor="mybox" className="form-label"><h1>{props.title}</h1></label>
                    <textarea id='mybox' value={inputText} onChange={handleOnChange} className="form-control" rows={8}></textarea>
                </div>
                <button onClick={handleUpClick} className="btn btn-primary mx-2">UpperCase</button>
                <button onClick={handleLoClick} className="btn btn-primary mx-2">LowerCase</button>
                <button onClick={handleClear} className="btn btn-primary mx-2">Clear</button>
                <button onClick={handleHtml} className="btn btn-primary mx-2">HTML to JSX</button>
            </div>

            <div className='my-3'>
                <h4>Words are: <strong>{words}</strong>  Letters are: <strong>{letters}</strong> </h4>
                <p>Time to read = {0.008 * words} Minutes</p>
                <h3>Preview</h3>
                <p>{inputText}</p>
            </div>

        </>
    )
}

export default Textform;